import React, {Component} from 'react';

class AppCatalogTableRow extends Component {

	  constructor(props) {
	    super(props);
	    this.state = ({display:true});
	  }

	  render() {
		var localAppName = this.props.app.applicationName;
		if(localAppName === undefined){
			localAppName = this.props.app.applicatioName;
		}
		if (this.state.display === false){
			return null;
		}
	    else return (
	      <tr>
	        <td>{localAppName}</td>
	        <td><i className={this.getAppStatusStyle(this.props.app.applicationStatus)}/> {this.props.app.applicationStatus}</td>
	        <td>{this.convertDate(this.props.app.applicationLiveDate, this.props.app.applicationSubmittedDate)}</td>
	        <td>{this.props.app.firstName} {this.props.app.lastName}</td>
	      </tr>);
	  }

	convertDate = (liveDate, submittedDate) => {
		var dateFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
		var dateEpoch = submittedDate;
		if(liveDate > submittedDate)	{
			dateEpoch = liveDate;
		}
		var date = new Date(0);
		date.setUTCSeconds(dateEpoch/1000);
		return date.toLocaleDateString('en-US', dateFormatOptions);
	}
	
	getAppStatusStyle = (applicationStatus) => {
		var style;
		switch(applicationStatus)	{
		case "Under Review":
			style = "fas fa-circle text-gray";
			break;
		case "Rejected":
			style = "fas fa-circle text-red";
			break;
		case "Approved":
		case "Live":
			style = "fas fa-circle text-green";
			break;
		case "Withdrawn":
		default:
			style = "fas fa-circle text-yellow";
		}
		return style;
	}
}

export default AppCatalogTableRow;


// WEBPACK FOOTER //
// ./src/manageMyAccount/AppCatalogTableRow.js